import { defineStore, createPinia } from 'pinia';
    
import { useUserStore } from '@/stores/user'


export const pinia = createPinia();

export const useAdminStore = defineStore('admin', {
  state: () => ({ colleagues: [], loginAs: null, isAdmin: null }),

  actions: {
    async loginAsUser(user) {
      const userStore = useUserStore();
      console.log('2. Logging in as user:', user);
      if (user) {
        try {
          this.loginAs = user;
          console.log('3. Set loginAs to:', this.loginAs);
          await userStore.login(user.emailAddress, this.loginAs);
        } catch (error) {
          console.error('Error logging in as user:', error);
        }
      }
    },
  },
});